export const LANGUAGES = {
  PT: "pt",
  EN: "en",
};

export const LANGUAGE_NAMES = {
  pt: "Português",
  en: "English",
};

export const SUPPORTED_LANGUAGES = Object.values(LANGUAGES);
